function HamburgerButton({onClick})
{
    return <div className="hamburgerButton" onClick={onClick}>
            <img src={'/media/images/icons/hamburgerIcon.png'} alt={'icon'}/>
        </div>
}

export default HamburgerButton